module.exports = __webpack_public_path__ + "img/code.246e751a.png";